import { useState, useEffect } from 'react';
import { api } from '@crm/shared';

// Module-level cache — lives for the browser session
let _cache = null;
let _promise = null;

const extractUsers = (response) => (
  Array.isArray(response?.data) ? response.data : []
);

const hasHierarchyFields = (users = []) => (
  users.length === 0 || users.some((user) => (
    Object.prototype.hasOwnProperty.call(user || {}, 'reporting_manager_id') ||
    Object.prototype.hasOwnProperty.call(user || {}, 'reporting_manager')
  ))
);

export function invalidateUsersCache() {
  _cache = null;
  _promise = null;
}

export function useAllUsers() {
  const [users,   setUsers]   = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache && hasHierarchyFields(_cache)) {
      setUsers(_cache);
      setLoading(false);
      return;
    }
    if (_cache && !hasHierarchyFields(_cache)) {
      _cache = null;
      _promise = null;
    }
    if (!_promise) {
      _promise = api.getAllActiveUsers()
        .then(res => {
          _cache = extractUsers(res);
          return _cache;
        })
        .catch(() => {
          _promise = null;
          return [];
        });
    }
    _promise.then(data => {
      setUsers(data);
      setLoading(false);
    });
  }, []);

  return { users, loading };
}
